import * as React from 'react'
import { unwindEdges } from '@good-idea/unwind-edges'
import { Product, ShopifyStorefrontSelectedOption } from '@/types'
import { ProductDetails } from './ProductDetails'
import { ProductImages } from './ProductImages'
import { ProductInner, ProductMain } from './styles'

const { useState } = React

interface ProductViewProps {
  product: Product
}

export const ProductView: React.FC<ProductViewProps> = ({ product }) => {
  const [variants] = unwindEdges(product.shopify.variants)
  const [selectedVariant, setSelectedVariantState] = useState(variants[0])

  const selectVariant = (
    selectedOptions: Omit<ShopifyStorefrontSelectedOption, '__typename'>[],
  ) => {
    const newVariant = variants.find((v) => {
      return v.selectedOptions.every((variantOption) =>
        selectedOptions.find(
          (so) =>
            so.name === variantOption.name && so.value === variantOption.value,
        ),
      )
    })
    if (newVariant) {
      setSelectedVariantState(newVariant)
    } else {
      console.warn('Could not find variant with these options', {
        selectedOptions,
        variants,
      })
    }
  }

  return (
    <ProductMain>
      <ProductInner>
        <ProductImages product={product} selectedVariant={selectedVariant} />
        <ProductDetails
          product={product}
          selectedVariant={selectedVariant}
          selectVariant={selectVariant}
        />
      </ProductInner>
    </ProductMain>
  )
}
